import { FC } from 'react';
import { AbsPageSharingCard } from '@lemon8/web-app-shared/ssr';
import { SugTDK } from './tdk';

export class SharingCardMeta extends AbsPageSharingCard {
  PageLevelTDK: FC = () => {
    return <SugTDK />;
  };
  PageLevelOGCard: FC = () => {
    return <></>;
  };
  PageLevelTWCard: FC = () => {
    return <></>;
  };
  PageLevelALMeta: FC = () => {
    return <></>;
  };
}
